import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation';
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from '../firebase';

const SouthieTimes = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const q = query(collection(db, 'articles'), orderBy('created_at', 'desc'));
        const querySnapshot = await getDocs(q);
        const articleList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setArticles(articleList);
      } catch (error) {
        console.error("Error fetching articles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  function getTimeAgo(timestamp) {
    const now = Date.now();
    const date = timestamp.toDate();
    const secondsAgo = Math.floor((now - date.getTime()) / 1000);

    if (secondsAgo < 604800) { // 604800 seconds = 1 week
      if (secondsAgo < 2) return `Just now`;
      if (secondsAgo < 60) return `${secondsAgo}s ago`;
      if (secondsAgo < 3600) return `${ Math.floor(secondsAgo / 60)}m ago`;
      if (secondsAgo < 86400) return `${ Math.floor(secondsAgo / 3600)}h ago`;
      return `${Math.floor(secondsAgo / 86400)}d ago`
    }

    // If it's more than a week ago, show full date
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return `${ date.toLocaleDateString(undefined, options) }`;
  }

  function articleClick (gameID) {
    navigate(`/articles/${gameID}`);
  }

  return (
    <div className="SouthieTimes">
      <div className="league-content">
        <div className="league-header">
          <div className="league-header-top">
            <p className="league-title-standard">Southie Times</p>
          </div>
        </div>

        <div className="league-body">
          <div className="league-table-container schedule">
            {loading ? (
              <LoadingAnimation />
            ) : (
              articles.length === 0 ? (
                <p>No articles available.</p>
              ) : (
                articles.map(article => (
                  <div className='game-article-container' onClick={ () => { articleClick(article.id) }} style={{ cursor: 'pointer' }}>
                    <p className='league-game-article-title'>{ article.title }</p>
                    <div>
                      { article.created_at.toDate && (new Date() - article.created_at.toDate() < 24 * 60 * 60 * 1000) && (
                        <span style={{ paddingRight: 0 }}>
                          <span style={{
                            color: '#B72424',
                            marginRight: '6px',
                            fontFamily: 'nyt-franklin, helvetica, arial, sans-serif',
                            fontSize: '12px',
                            fontWeight: 700,
                            letterSpacing: '.08em'
                          }}>
                            • LIVE
                          </span>
                        </span>
                      )}

                      <label className='league-comment-date'><span>{ getTimeAgo(article.created_at) }</span></label>
                    </div>
                    <p className='league-game-article-summary'>{ article.summary }</p>
                  </div>
                ))
              )
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SouthieTimes;
